// Module
var code = "<a :href=\"href\" class=\"ad-banner\" target=\"_blank\">\n  <slot></slot>\n  <icon name=\"ion-android-open\" />\n</a>\n";
// Exports
export default code;